import { Component, OnInit, Inject, HostListener, ElementRef, ViewChild, ChangeDetectorRef, TemplateRef, ViewContainerRef } from '@angular/core';
import {CompactType, DisplayGrid, Draggable, GridsterConfig, GridsterItem, GridType, PushDirections, Resizable} from 'angular-gridster2';
import { OauthService} from '../service/oauth.service';
import { ViewobserverService } from '../service/viewobserver.service';
import { fromEvent, Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateEditSpace, DialogOverviewConfirm, DialogOverviewExampleDialog } from '../cards/cards.component'
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { TelemetryService } from '../service/telemetry.service';
import { UserInterface } from '../models/user';
import { take, filter } from 'rxjs/operators';
import { MatSidenav} from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import {ThemePalette} from '@angular/material/core';
import {FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { duration } from 'moment';
import { AppComponent } from '../app.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { BQRequestService } from '../service/bqrequest.service';
import { AlarmsqueryService } from '../service/alarmsquery.service';

export interface DialogData {
  city: string;
  office: string;
  model: string;
  name: string;
  zone: string;
  value1?: number;
  value2?: number;
  value3?: number;
  value4?: number;
  chartdata: any;
  devType: string;
  out: string;
}

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

interface Safe extends GridsterConfig{
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}


@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.css']
})
export class ControlsComponent implements OnInit {
  public InitialLoadingPromise = Promise.resolve(false);
  //interfaces
  user: UserInterface = {
    name: '',
    photoUrl: '',
    isLogged: false,
    email: '',
    roles: { 
      viewer: false,
      admin: false,
    },
  };
  markers: MarkerInterface[];

  //views
  @ViewChild('sideNav', { static: true }) sidenav: MatSidenav;
  @ViewChild('search', { static: false }) searchElementRef: ElementRef;
  overlayRef: OverlayRef | null;
  @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;
  options: Safe;
  dashboard: Array<GridsterItem>;

  //p vars
  isMobile: boolean = false;
  public myNewDims;
  public myNewDims2;
  public date: Date = new Date();

  public Spaces = [];
  public Snames = [];
  public TabIndex = ""; //para cambiar entre los diferentes espacios disponibles
  public Devices = [];
  public userUid;
  public dashSubs = [];
  public SpaceLimit = 3;

  //subs area
  private marksSub;
  private subObserver;
  private usrSub;
  private sub;
  public intervalTime;

  //controls
  public devicesData = new MatTableDataSource;
  public filteredDevices: Observable<any[]>;
  public side_menu_state: boolean = false;
  SearchBarControl = new FormControl();

  public updateOnExit: boolean = false;



  @HostListener('window:resize', ['$event'])
    sizeChange($event){
      this.myNewDims = window.innerHeight - 45;
      this.myNewDims2 = window.innerHeight -88;
    }
  
  @HostListener('window:beforeunload', [ '$event' ])
  onPageUnload($event: BeforeUnloadEvent) {
    if (this.updateOnExit) {
      $event.returnValue = true;
      this.authService.UpdateUserDashboardControl(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
      this.updateOnExit = false;
      this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
    }
  }

  constructor(private authService: OauthService, 
    private observer: ViewobserverService,
    private markersService: MarkersService,
    private telemetryService: TelemetryService,
    private dialog: MatDialog,
    public appComponent: AppComponent,
    private cdr: ChangeDetectorRef,
    private snack: MatSnackBar,
    public overlay: Overlay,
    private alarms: AlarmsqueryService,
    public viewContainerRef: ViewContainerRef,
    private iot: BQRequestService) {
      //seteo loop que ocurre cada 1min
      this.intervalTime = setInterval(() => {
        this.date = new Date();
        //aqui reviso los ultimos datos recibidos
        for(let s in this.dashboard)
        {
          if(this.dashboard[s].widgetType != 'Clock')
          {
            let id = this.dashboard[s].id
            let lastSeen = new Date(this.dashboard[s].lastSeen);
            let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
            if(timeElapsed > 30){
              if(this.dashboard[s].widgetType == 'Output')
              {
                document.getElementById(id+'stateOut').style.backgroundColor = 'red';
              }
              if(this.dashboard[s].widgetType == 'Input')
              {
                document.getElementById(id+'stateIn').style.backgroundColor = 'red';
              }              
            }
            else
            {
              if(this.dashboard[s].widgetType == 'Output')
              {
                document.getElementById(id+'stateOut').style.backgroundColor = 'green';
              }
              if(this.dashboard[s].widgetType == 'Input')
              {
                document.getElementById(id+'stateIn').style.backgroundColor = 'green';
              }              
            }
          }
        }
      }, 30000);
      
     }

  ngOnInit() {
    
    //-------- Opciones para el gridster --------
    this.options = {
      gridType: GridType.ScrollHorizontal,
      compactType: CompactType.None,
      margin: 10,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      useTransformPositioning: true,
      mobileBreakpoint: 640,
      minCols: 6,
      maxCols: 9,
      minRows: 4,
      maxRows: 4,
      maxItemCols: 100,
      minItemCols: 1,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemArea: 2500,
      minItemArea: 1,
      defaultItemCols: 1,
      defaultItemRows: 1,
      fixedColWidth: 255,
      fixedRowHeight: 250,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      enableOccupiedCellDrop: false,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: false,
      draggable: {
        enabled: true,
        stop: function (event, $element, widget) {
          if($element['drag']['lastMouse']['clientX'] != 0 || $element['drag']['lastMouse']['clientY'] != 0)
          {this.updateOnExit = true }
        }.bind(this)
      },
      resizable: {
        enabled: true,
      },
      swap: true,
      pushItems: false,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushDirections: {north: true, east: true, south: true, west: true},
      pushResizeItems: false,
      displayGrid: DisplayGrid.OnDragAndResize,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false
    };
    //-------------------------------------------

    this.dashboard = [
      {cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'},
      // {cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'TempOnly', resizeEnabled: false, label: '', telemetry: '', lastSeen: ''},
      // {cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'Energy3P', resizeEnabled: false, label: 'Widget 3', telemetry: {v1: 123, v2: 123, v3: 123, 
      //                                                                                                          i1: 123, i2: 123, i3: 123,
      //                                                                                                          s1: 123, s2: 123, s3: 123,
      //                                                                                                          freq: 60, fp: 0.9}           , lastSeen: null},
      // {cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'Energy3P', resizeEnabled: false, label: 'Widget 4', telemetry: {v1: 123, v2: 123, v3: 123, 
      //                                                                                                           i1: 123, i2: 123, i3: 123,
      //                                                                                                           s1: 123, s2: 123, s3: 123,
      //                                                                                                           freq: 60, fp: 0.9}           , lastSeen: null},
      // {cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'TempOnly', resizeEnabled: false, label: '', telemetry: '', lastSeen: ''},
      // {cols: 1, rows: 2, y: 3, x: 5, dragEnabled: true, widgetType: 'TempOnlyGraph', resizeEnabled: true, label: '', telemetry: '', lastSeen: ''},
      // {cols: 1, rows: 1, y: 2, x: 1, dragEnabled: true, widgetType: 'Empty', resizeEnabled: true, label: 'Drag&Resize Enabled', telemetry: 50},
      // {cols: 1, rows: 1, y: 4, x: 5, dragEnabled: true, widgetType: 'TempOnlyGauge', resizeEnabled: true, label: '', telemetry: '', lastSeen: ''},
    ];

    this.myNewDims = window.innerHeight -45;
    this.myNewDims2 = window.innerHeight -88;

    this.delay(500).then(any=>{
        
      //this.cdr.detach();
      //this.authService.UpdateUserDashboardMonitoring(this.appComponent.userUid, this.dashboard, "Space1");
      // retrieve spaces alias and dashboards by user
      let sub = this.authService.getUserDashboardMonitoring(this.appComponent.userUid).subscribe( data => {
        console.log(this.appComponent.selectedProyect);
        let projID = this.appComponent.selectedProyect['id'];
        if(data['IOSpaces'] != undefined)
        {
          for(let space in data['IOSpaces'][projID]){
            this.Spaces.push(data['IOSpaces'][projID][space])
          }
          for (let Snames in data["IOSpacesAlias"][projID]){
            this.Snames.push(data["IOSpacesAlias"][projID][Snames]);
          }
          this.SpaceLimit = data['SpaceLimit'];
          sub.unsubscribe();
          this.TabIndex = this.Snames[0];
          this.dashboard = this.Spaces[0];

          this.InitialLoadingPromise = Promise.resolve(false);//se resuelve la promesa para dibujar el dashboard
          console.log(this.dashboard);
          //una vez cargado los datos desde Firestore iniciar los subscribe (flujo de datos)
          this.delay(5).then(any =>{              
            for(let s in this.dashboard){
              //this.cdr.detectChanges();
              this.dashSubs.push({s: ''});
              //aqui crear los subs
              if (this.dashboard[s].widgetType == 'Clock'){continue} //skip clock widget
              if (this.dashboard[s].widgetType == 'Input'){ //sub for MT simple widget
                this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                  //update temp and timestamp
                  this.dashSubs[s].Input = result['Input'];
                  if(result['Input'])
                  {
                    (document.getElementById(this.dashboard[s].id+'In') as HTMLInputElement).checked = true;
                  }
                  else
                  {
                    (document.getElementById(this.dashboard[s].id+'In') as HTMLInputElement).checked = false;
                  }
                  this.dashboard[s].lastSeen = result['timestamp'];
                  document.getElementById(this.dashboard[s].id+'stateIn').title = 'Ultimo dato: '+result['timestamp']
                  let lastSeen = new Date(this.dashboard[s].lastSeen);
                  let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                  if(timeElapsed > 30)
                  {
                    document.getElementById(this.dashboard[s].id+'stateIn').style.backgroundColor = 'red';
                  }
                  if(result['State']['auto'] && result['State']['man'])
                  {
                    document.getElementById(this.dashboard[s].id+'Dial').style.transform = 'rotate(145deg)'
                  }
                  if(result['State']['auto'] && !result['State']['man'])
                  {
                    document.getElementById(this.dashboard[s].id+'Dial').style.transform = 'rotate(90deg)'
                  }
                  if(!result['State']['auto'] && !result['State']['man'])
                  {
                    document.getElementById(this.dashboard[s].id+'Dial').style.transform = 'rotate(28deg)'
                  }
                })
              }
              if (this.dashboard[s].widgetType == 'Output'){ //sub for MT simple widget
                this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                  //update temp and timestamp
                  this.dashSubs[s].Input = result['Output'];

                  if(result['Output'])
                  {
                    (document.getElementById(this.dashboard[s].id+'Out') as HTMLInputElement).checked = true;
                  }
                  else
                  {
                    (document.getElementById(this.dashboard[s].id+'Out') as HTMLInputElement).checked = false;
                  }
                  this.dashboard[s].lastSeen = result['timestamp'];
                  document.getElementById(this.dashboard[s].id+'stateOut').title = 'Ultimo dato: '+result['timestamp'];
                  let lastSeen = new Date(this.dashboard[s].lastSeen);
                  let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                  if(timeElapsed > 30)
                  {
                    document.getElementById(this.dashboard[s].id+'stateOut').style.backgroundColor = 'red';
                  }
                })
              }

            }
          //retrieves the telemetry from "id"
          // var dummy = 'Sierra-Checa-Calle-MTCocina'.split("-");
          // this.dashboard[1].label = dummy[1]+"/"+dummy[2]+" "+dummy[3];
          // this.MTSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-MTCocina').subscribe(result =>{
          //   let temp = this.round(result['Temp'] ,1);
          //   //update current
          //   let dummy = result['timestamp'].split(' ');
          //   let dummy2 = dummy[0].split('-');
          //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
          //   let fullfixed = date+' '+dummy[1];
          //   var d = new Date(fullfixed);
          //   this.dashboard[1].telemetry = temp;
          //   this.dashboard[1].lastSeen = d;
          // });

          // var dummy2 = 'Sierra-Checa-Calle-TTACOMAP'.split("-");;
          // this.dashboard[2].label = dummy2[1]+'/'+dummy2[2] + ' '+dummy2[3] 
          // this.PMSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TTACOMAP').subscribe(result =>{
          //   //this.telemetrys = result;
          //   //update current
          //   let dummy = result['timestamp'].split(' ');
          //   let dummy2 = dummy[0].split('-');
          //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
          //   let fullfixed = date+' '+dummy[1];
          //   var d = new Date(fullfixed);
          //   this.dashboard[2].lastSeen = d;
          //   this.dashboard[2].telemetry.v1 = result['v1'];
          //   this.dashboard[2].telemetry.v2 = result['v2'];
          //   this.dashboard[2].telemetry.v3 = result['v3'];
          //   this.dashboard[2].telemetry.i1 = result['c1'];
          //   this.dashboard[2].telemetry.i2 = result['c2'];
          //   this.dashboard[2].telemetry.i3 = result['c3'];
          //   this.dashboard[2].telemetry.s1 = result['s1'];
          //   this.dashboard[2].telemetry.s2 = result['s2'];
          //   this.dashboard[2].telemetry.s3 = result['s3'];
          //   this.dashboard[2].telemetry.freq = result['freq'];
          //   this.dashboard[2].telemetry.fp = result['fp'];

          // });

          // var dummy3 = 'Sierra-Checa-Calle-PMCASA'.split("-");;
          // this.dashboard[3].label = dummy3[1]+'/'+dummy3[2] + ' '+dummy3[3] 
          // this.PMSub2 = this.telemetryService.getTelemetry('Sierra-Checa-Calle-PMCASA').subscribe(result =>{
          //   //this.telemetrys = result;
          //   //update current
          //   let dummy = result['timestamp'].split(' ');
          //   let dummy2 = dummy[0].split('-');
          //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
          //   let fullfixed = date+' '+dummy[1];
          //   var d = new Date(fullfixed);
          //   this.dashboard[3].lastSeen = d;
          //   this.dashboard[3].telemetry.v1 = result['v1'];
          //   this.dashboard[3].telemetry.v2 = result['v2'];
          //   this.dashboard[3].telemetry.v3 = result['v3'];
          //   this.dashboard[3].telemetry.i1 = result['c1'];
          //   this.dashboard[3].telemetry.i2 = result['c2'];
          //   this.dashboard[3].telemetry.i3 = result['c3'];
          //   this.dashboard[3].telemetry.s1 = result['s1'];
          //   this.dashboard[3].telemetry.s2 = result['s2'];
          //   this.dashboard[3].telemetry.s3 = result['s3'];
          //   this.dashboard[3].telemetry.freq = result['freq'];
          //   this.dashboard[3].telemetry.fp = result['fp'];

          // });

          // var dummy4 = 'Sierra-Checa-Calle-TempMaster'.split("-");;
          // this.dashboard[4].label = dummy4[1]+'/'+dummy4[2] + ' '+dummy4[3];
          // this.dashboard[5].label = dummy4[1]+"/"+dummy4[2]+" "+dummy4[3];
          // let otherm = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TempMaster').subscribe(result =>{
          //   let temp = this.round(result['Temp'] ,1);
          //   let elementT = document.getElementById('temperature');
          //   elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
          //   elementT.dataset.value = temp + "°C";
          //   //update current
          //   let dummy = result['timestamp'].split(' ');
          //   let dummy2 = dummy[0].split('-');
          //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
          //   let fullfixed = date+' '+dummy[1];
          //   var d = new Date(fullfixed);
          //   this.dashboard[4].telemetry = temp;
          //   this.dashboard[6].telemetry = (temp - 0) / (100 - 0) * 100;
          //   this.dashboard[4].lastSeen = d;
          //   this.dashboard[5].lastSeen = d;
          // });
            
          })
        }
        else
        {
          this.Snames = ['Default'];
          this.TabIndex = this.Snames[0];
          this.InitialLoadingPromise = Promise.resolve(false);
          console.log(this.userUid)
          this.authService.createUserIODash(this.userUid, this.dashboard, this.appComponent.selectedProyect['id']);
        }
      })      
    })

    //------ Gets current user logged in and retrieve places-devices ------
    this.delay(50).then(any=>{
      this.getCurrentUser();
      
      //retrieves the markers to place in map
      this.marksSub = this.markersService.getMarkers().subscribe(marker =>{
        this.markers = marker;
        for(let site in marker)
        {
          for(let typedev in marker[site]["devices"])
          {
            for(let dev in marker[site]["devices"][typedev])
            {
              if(marker[site]["devices"][typedev][dev].type == 'IO')
              {
                let body = marker[site]["devices"][typedev][dev];
                body.zone = marker[site]["zone"];
                body.city = marker[site]["city"];
                body.office = marker[site]["office"];
                body.InAlias = marker[site]["devices"][typedev][dev]["InAlias"];
                body.OutAlias = marker[site]["devices"][typedev][dev]["OutAlias"];
                this.Devices.push(body);
              }
            }
          }
        }
        console.log(this.Devices);
        this.devicesData = new MatTableDataSource(this.Devices);
        this.filteredDevices = this.SearchBarControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
        
    })

    //observer to get view size 
    this.subObserver = this.observer.getMode().subscribe(result =>{
      this.isMobile = result.matches;
    })

    // ///retrieves alarms to plot
    // this.subAlarms = this.alarmService.getAlarms().subscribe(res => {
    //   let timestamp = res.map(res => res['timestamp']);
    //   let value = res.map(res => res['value']);
    // })
    });
  }

  ////funciones gridster
  changeOptions(): void{
    if (this.options.api && this.options.api.optionsChanged){
      this.options.api.optionsChanged();
    }
  }

  removeItem($event: MouseEvent | TouchEvent, item): void {
    $event.preventDefault();
    $event.stopPropagation();//se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    let index = this.dashboard.indexOf(item);
    console.log(this.dashSubs[index]);
    if(this.dashSubs[index].sub != undefined){
      this.dashSubs[index].sub.unsubscribe();
    }

    this.dashboard.splice(this.dashboard.indexOf(item), 1);
    this.dashSubs.splice(this.dashboard.indexOf(item), 1);
    //this.explode($event.clientX - 100, $event.clientY);
    //se actualiza el dashboard en backend
    //se quitan los objetos en variable dashboard.
    // let dummyDash = [];
    //   this.dashboard.forEach(element => {
    //     if(element.sub != undefined)
    //       {
    //         element.sub = '';
    //       }
    //     dummyDash.push(element);
    //   });
    this.authService.UpdateUserDashboardControl(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
  }

  addItem(): void {
    this.dashboard.push({x: 0, y: 0, cols: 1, rows: 1});
  }

  ngOnDestroy(){
    this.sizeChange = function() : void {};
    //console.log('desuscrito de todo /Eficiency')
    if (this.updateOnExit) {  //se guarda en BDD si es necesario
      console.log(this.dashboard)
      this.authService.UpdateUserDashboardControl(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
      this.updateOnExit = false;
      this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
    }
    
    try {
      for(let widget in this.dashSubs){
        if(widget != '0'){this.dashSubs[widget].sub.unsubscribe();}
      }      
    } catch (error) {
      console.log(error)
    }
    clearInterval(this.intervalTime);
    
    
    this.dashboard = [];
    this.marksSub.unsubscribe();
    this.subObserver.unsubscribe();
    // this.subAlarms.unsubscribe();
    this.usrSub.unsubscribe();

  }

  //------- abre ventana de grafico -----------------
  openDialog(item, devtype, event): void {
    console.log(event);
    if(event == 'div')
    {
      if (devtype == 'OUT'){
        let alias = item.label.split(' ');
        alias = alias.slice(1).join(' ');
        let dummy = item.id.split('-');
        if(dummy.length >= 4 ){
          let dummy2 = dummy;
          dummy[3] = dummy2.slice(3,dummy2.length).join('-');
        }
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
          data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: 'IO', alias: alias, devices: this.Devices}
        });
      }      
    }
    
    
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'MT'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedMTDevName, zone: this.selectedDevCity, model: this.selectedMTDevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype, alias: this.selectedMTDevAlias}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'IO'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedIODevName, zone: this.selectedDevCity, model: this.selectedIODevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'UPS'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedUPSDevName, zone: this.selectedDevCity, model: this.selectedUPSDevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype, alias: this.selectedUPSDevAlias}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    
  }

  //toggle
  toggle(event){
    //console.log(event)
  }

  //--------- Para agregar widget de Salida -------
  addOutWidget(Gtype, id, alias, name){
    //Simple solo numeros
    if(Gtype == 'simple')
    {
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'Output', resizeEnabled: false, label: label, name: name, telemetry: '', lastSeen: null, id: id, Output: false, Q: ''});
      this.dashSubs.push({s: ''});
      //-----Aqui va el sub de datos para rellenar temp simple
      this.dashboard[s].lastSeen = null
      //desactivado por dispositivos inventados
      this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
        console.log(result);
        this.dashboard[s].Q = result['Q'];
        //update temp and timestamp
        let dummy = result['timestamp'].split(' ');
        let dummy2 = dummy[0].split('-');
        let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
        let fullfixed = date+' '+dummy[1];
        var d = new Date(fullfixed);
        this.dashboard[s].Output = result['Output'];
        this.dashboard[s].Levas = [];
        this.dashboard[s].Levas.push(result['Leva1']);
        this.dashboard[s].Levas.push(result['Leva2']);
        this.dashboard[s].Levas.push(result['Leva3']);
        if(result['Output'])
        {
          (document.getElementById(id+'Out') as HTMLInputElement).checked = true;
        }
        else
        {
          (document.getElementById(id+'Out') as HTMLInputElement).checked = false;
        }
        this.dashboard[s].lastSeen = d;
        document.getElementById(id+'stateOut').title = 'Ultimo dato: '+result['timestamp']        

      })
      console.log(this.dashboard[s]);

    }
    let Ddash = [];
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    for(let index of this.dashboard)
    {
      Ddash.push(index);  
    }
    console.log(this.userUid, Ddash, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    this.authService.UpdateUserDashboardControl(this.userUid, Ddash, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    //se cierra el sidenav
    this.sidenav.toggle();
  }

   //--------- Para agregar widget de Entrada -------
   addInWidget(Gtype, id, alias, name){
    //Simple solo numeros
    if(Gtype == 'simple')
    {
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'Input', resizeEnabled: false, label: label, name: name, telemetry: '', lastSeen: '', id: id, Input: false});
      this.dashSubs.push({s: ''});
      //-----Aqui va el sub de datos para rellenar temp simple
      this.dashboard[s].lastSeen = null
      //desactivado por dispositivos inventados
      console.log(this.dashboard[s].id);
      this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
        //update temp and timestamp
        this.dashboard[s].Input = result['Input'];
        if(result['Input'])
        {
          (document.getElementById(id+'In') as HTMLInputElement).checked = true;
        }
        else
        {
          (document.getElementById(id+'In') as HTMLInputElement).checked = false;
        }
        let dummy = result['timestamp'].split(' ');
        let dummy2 = dummy[0].split('-');
        let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
        let fullfixed = date+' '+dummy[1];
        var d = new Date(fullfixed);
        this.dashboard[s].lastSeen = d;
        let elapsed = new Date().getTime() - new Date(fullfixed).getTime();
        console.log(elapsed)
        document.getElementById(id+'stateIn').title = 'Ultimo dato: '+result['timestamp']
      })
      console.log(this.dashboard[s]);

    }
    let Ddash = [];
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    for(let index of this.dashboard)
    {
      Ddash.push(index);
    }

    this.authService.UpdateUserDashboardControl(this.userUid, Ddash, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    //se cierra el sidenav
    this.sidenav.toggle();
  }

  //-----------Abre ventana de confirmacion----------------
  openConfirmDialog(event, item): void {
    if(item == 'delete')
    {
      const dialogRef = this.dialog.open(DialogOverviewConfirm, {
        width: '250px',
        data: 'Borrar Espacio'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "ok"){this.deleteSpace('delete')}
      });
    }
    else
    {
      const dialogRef = this.dialog.open(DialogOverviewConfirm, {
        width: '250px',
        data: item
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "ok"){this.removeItem(event, item)}
      });
    }
  }

  //------- Abre la ventana de levas ----------------------
  openConfigDialog(event, item): void{
    console.log(item);
    let dummy = item.id.split('-');
      const dialogRef = this.dialog.open(ConfigDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], levas: item['Levas'], Q: item['Q']}
      });

    dialogRef.afterClosed().subscribe(resutl => {
      if(resutl != undefined)
      {
        let leva1 = resutl[0];
        let leva2 = resutl[1];
        let dummy = item.id.split('-');
        let registry = [dummy[0], dummy[1], dummy[2]].join('-');
        let devname = dummy[3];
        let deviceupdt = [dummy[0], dummy[1], dummy[2], dummy[3]].join('-');
        console.log(registry, devname, leva1, leva2);
        //this.authService.UpdateUserDashboardControl(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
        this.alarms.updateIOConfig(registry, deviceupdt, resutl);

        this.iot.sendIOUpdate(registry, devname, leva1, leva2).subscribe(resutl =>{
          console.log(resutl);
        })
      }
    });
  }

  //funcion para filtrar los sites
  private _filter(value: string): Object[] {
    this.devicesData.filter = value.trim().toLowerCase();
    let result: object[] = [];
    for (let index = 0; index < this.devicesData.filteredData.length; index++) {
      result.push({'city': this.devicesData.filteredData[index]['city'], 'office': this.devicesData.filteredData[index]['office'], 'type': this.devicesData.filteredData[index]['type'], 'zone': this.devicesData.filteredData[index]['zone'], 'alias': this.devicesData.filteredData[index]['alias'], 'bd_id': this.devicesData.filteredData[index]['bd_id'], 'InAlias': this.devicesData.filteredData[index]['InAlias'], 'OutAlias': this.devicesData.filteredData[index]['OutAlias']});
    }
    return result;
    // return [{"s": "a"}]
  }

  //gets current user
  getCurrentUser(){
    this.usrSub = this.authService.isAuth().subscribe( user => {
    if (user){
      //console.log('User logged as: ', user.displayName);
      this.user.isLogged = true;
      this.user.photoUrl = user.photoURL;
      this.userUid = user.uid;
      
    } else {
      //console.log('not logged');
      this.user.isLogged = false;
    }
  })
  }

  //funcion de delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("T= ", ms));
  }

  //------- abre ventana de nuevo espacio ------------
  openNewSpaceDialog(context): void {
    if(context == 'new')
    {
      const dialogRef = this.dialog.open(CreateEditSpace, {
        width: '250px',
        data: {id: null, context: 'new'}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result == 'ok'){console.log('no se crea nada')}
        else
        {
          if(this.Snames.length <  this.SpaceLimit)
          {this.createSpace(result.data);}
          else
          {this.snack.open('Limite superado, contacta con soporte para incrementar limite de espacios', '', { duration: 3000 })}
          
        }
      });
    }
    if(context == 'edit'){
      const dialogRef = this.dialog.open(CreateEditSpace, {
        width: '250px',
        data: {id: this.TabIndex, context: 'edit'}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result == 'ok'){console.log('no cambia nada')}
        else
        {
          console.log(result.data);
          this.updateSpaceName(result.data);
        }
      });
    }

  }

  createSpace(name)
  {
    console.log(name, this.Snames.indexOf(this.TabIndex));
    this.Snames.push(name);
    this.Spaces.push([{cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'}])
    let index = this.Snames.indexOf(name);
    this.authService.createUserIODashSpace(this.userUid, index, this.Snames, this.appComponent.selectedProyect['id']);
    this.ChangeSpaceTab(name);
    //actualiza la vista manualmente
    //this.cdr.detectChanges();
  }

  updateSpaceName(item){
    this.Snames[this.Snames.indexOf(this.TabIndex)] = item;
    this.authService.UpdateIOSpaceName(this.userUid, this.Snames, this.appComponent.selectedProyect['id']);
    this.TabIndex = item;
    this.snack.open('Actualizado nombre de espacio', '', {duration: 1000});
    //actualiza la vista manualmente
    //this.cdr.detectChanges();
  }

  deleteSpace(item){
    let index = this.Snames.indexOf(this.TabIndex);
    this.Snames.splice(index, 1);
    this.Spaces.splice(index, 1);
    console.log(this.Spaces);
    let body = {};
    for(let dash in this.Spaces) //transform array to obj for firebase
    {
      body[dash] = this.Spaces[dash];
    }
    this.authService.deleteUserIOSpace(this.userUid, body, this.Snames, this.appComponent.selectedProyect['id']);

    this.updateOnExit = false
    this.ChangeSpaceTab(this.Snames[0]);
    //actualiza la vista manualmente
    //this.cdr.detectChanges();
  }

  ChangeSpaceTab(id){
    if(id != this.TabIndex) //si no se cambia el indice no se hace nada.....
    {
      this.InitialLoadingPromise = Promise.resolve(true);
      

      if (this.updateOnExit) {  //se guarda en BDD si es necesario
        this.authService.UpdateUserDashboardControl(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
        this.updateOnExit = false;
        this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
      }
      
      for(let widget in this.dashSubs){
        if(widget != '0'){this.dashSubs[widget].sub.unsubscribe();console.log('unsubs!')}
      }
      console.log('desuscrito de todo!')

      let index = this.Snames.indexOf(id); //set the index to new dashboard
      this.TabIndex = id;
      this.dashSubs = []; //reinicio dashsubs para evitar errores.
      this.dashboard = this.Spaces[index];
      this.delay(5).then(any =>{              
        for(let s in this.dashboard){
          //this.cdr.detectChanges();
          this.dashSubs.push({s: ''});
          //aqui crear los subs
          if (this.dashboard[s].widgetType == 'Clock'){continue} //skip clock widget
          if (this.dashboard[s].widgetType == 'Input'){ //sub for MT simple widget
            this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              //update temp and timestamp
              this.dashSubs[s].Input = result['Input'];
              if(result['Input'])
              {
                (document.getElementById(this.dashboard[s].id+'In') as HTMLInputElement).checked = true;
              }
              else
              {
                (document.getElementById(this.dashboard[s].id+'In') as HTMLInputElement).checked = false;
              }
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'stateIn').title = 'Ultimo dato: '+result['timestamp']
            })
          }
          if (this.dashboard[s].widgetType == 'Output'){ //sub for MT simple widget
            this.dashSubs[s].sub = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              //update temp and timestamp
              this.dashSubs[s].Input = result['Output'];

              if(result['Output'])
              {
                (document.getElementById(this.dashboard[s].id+'Out') as HTMLInputElement).checked = true;
              }
              else
              {
                (document.getElementById(this.dashboard[s].id+'Out') as HTMLInputElement).checked = false;
              }
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'stateOut').title = 'Ultimo dato: '+result['timestamp']
            })
          }

        }
      //retrieves the telemetry from "id"
      // var dummy = 'Sierra-Checa-Calle-MTCocina'.split("-");
      // this.dashboard[1].label = dummy[1]+"/"+dummy[2]+" "+dummy[3];
      // this.MTSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-MTCocina').subscribe(result =>{
      //   let temp = this.round(result['Temp'] ,1);
      //   //update current
      //   let dummy = result['timestamp'].split(' ');
      //   let dummy2 = dummy[0].split('-');
      //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
      //   let fullfixed = date+' '+dummy[1];
      //   var d = new Date(fullfixed);
      //   this.dashboard[1].telemetry = temp;
      //   this.dashboard[1].lastSeen = d;
      // });

      // var dummy2 = 'Sierra-Checa-Calle-TTACOMAP'.split("-");;
      // this.dashboard[2].label = dummy2[1]+'/'+dummy2[2] + ' '+dummy2[3] 
      // this.PMSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TTACOMAP').subscribe(result =>{
      //   //this.telemetrys = result;
      //   //update current
      //   let dummy = result['timestamp'].split(' ');
      //   let dummy2 = dummy[0].split('-');
      //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
      //   let fullfixed = date+' '+dummy[1];
      //   var d = new Date(fullfixed);
      //   this.dashboard[2].lastSeen = d;
      //   this.dashboard[2].telemetry.v1 = result['v1'];
      //   this.dashboard[2].telemetry.v2 = result['v2'];
      //   this.dashboard[2].telemetry.v3 = result['v3'];
      //   this.dashboard[2].telemetry.i1 = result['c1'];
      //   this.dashboard[2].telemetry.i2 = result['c2'];
      //   this.dashboard[2].telemetry.i3 = result['c3'];
      //   this.dashboard[2].telemetry.s1 = result['s1'];
      //   this.dashboard[2].telemetry.s2 = result['s2'];
      //   this.dashboard[2].telemetry.s3 = result['s3'];
      //   this.dashboard[2].telemetry.freq = result['freq'];
      //   this.dashboard[2].telemetry.fp = result['fp'];

      // });

      // var dummy3 = 'Sierra-Checa-Calle-PMCASA'.split("-");;
      // this.dashboard[3].label = dummy3[1]+'/'+dummy3[2] + ' '+dummy3[3] 
      // this.PMSub2 = this.telemetryService.getTelemetry('Sierra-Checa-Calle-PMCASA').subscribe(result =>{
      //   //this.telemetrys = result;
      //   //update current
      //   let dummy = result['timestamp'].split(' ');
      //   let dummy2 = dummy[0].split('-');
      //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
      //   let fullfixed = date+' '+dummy[1];
      //   var d = new Date(fullfixed);
      //   this.dashboard[3].lastSeen = d;
      //   this.dashboard[3].telemetry.v1 = result['v1'];
      //   this.dashboard[3].telemetry.v2 = result['v2'];
      //   this.dashboard[3].telemetry.v3 = result['v3'];
      //   this.dashboard[3].telemetry.i1 = result['c1'];
      //   this.dashboard[3].telemetry.i2 = result['c2'];
      //   this.dashboard[3].telemetry.i3 = result['c3'];
      //   this.dashboard[3].telemetry.s1 = result['s1'];
      //   this.dashboard[3].telemetry.s2 = result['s2'];
      //   this.dashboard[3].telemetry.s3 = result['s3'];
      //   this.dashboard[3].telemetry.freq = result['freq'];
      //   this.dashboard[3].telemetry.fp = result['fp'];

      // });

      // var dummy4 = 'Sierra-Checa-Calle-TempMaster'.split("-");;
      // this.dashboard[4].label = dummy4[1]+'/'+dummy4[2] + ' '+dummy4[3];
      // this.dashboard[5].label = dummy4[1]+"/"+dummy4[2]+" "+dummy4[3];
      // let otherm = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TempMaster').subscribe(result =>{
      //   let temp = this.round(result['Temp'] ,1);
      //   let elementT = document.getElementById('temperature');
      //   elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
      //   elementT.dataset.value = temp + "°C";
      //   //update current
      //   let dummy = result['timestamp'].split(' ');
      //   let dummy2 = dummy[0].split('-');
      //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
      //   let fullfixed = date+' '+dummy[1];
      //   var d = new Date(fullfixed);
      //   this.dashboard[4].telemetry = temp;
      //   this.dashboard[6].telemetry = (temp - 0) / (100 - 0) * 100;
      //   this.dashboard[4].lastSeen = d;
      //   this.dashboard[5].lastSeen = d;
      // });
        
      })
      console.log(this.dashSubs);
      this.InitialLoadingPromise = Promise.resolve(false);
    }
    //this.cdr.detectChanges();
  }

  onContextMenu($event: MouseEvent, name) {
    console.log($event);

    let x= $event.clientX;
    let y= $event.clientY;
    //this.close();
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(this.contextMenu, this.viewContainerRef, {
      $implicit: name
    }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
        }),
        take(1)
      ).subscribe(() => this.close())

    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  close() {
    //this.cdr.detectChanges();
    this.sub && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  changeOutState(id, state){
    if(state == 'auto')
    {
      document.getElementById(id+'Dial').style.transform = 'rotate(28deg)'
      let payload = {'man': false, 'auto': false}
      let dummy = id.split('-');
      let registry = [dummy[0], dummy[1], dummy[2]].join('-');
      let devname = dummy[3];
      this.iot.sendIoTCommand(registry, devname, payload).subscribe(result =>{
        console.log(result)
      })
    }
    if(state == 'off')
    {
      document.getElementById(id+'Dial').style.transform = 'rotate(90deg)'
      let payload = {'man': false, 'auto': true}
      let dummy = id.split('-');
      let registry = [dummy[0], dummy[1], dummy[2]].join('-');
      let devname = dummy[3];
      this.iot.sendIoTCommand(registry, devname, payload).subscribe(result =>{
        console.log(result)
      })
    }
    if(state == 'on')
    {
      document.getElementById(id+'Dial').style.transform = 'rotate(145deg)'
      let payload = {'man': true, 'auto': true}
      let dummy = id.split('-');
      let registry = [dummy[0], dummy[1], dummy[2]].join('-');
      let devname = dummy[3];
      this.iot.sendIoTCommand(registry, devname, payload).subscribe(result =>{
        console.log(result)
      })
    }
  }

  sendConfig(id, payload)
  {
    const projectId = this.appComponent.selectedProyect;
    const deviceId = `myDevice`;
    const registryId = `myRegistry`;
    const region = `us-central1`;
    // const algorithm = `RS256`;
    // const privateKeyFile = `./rsa_private.pem`;
    // const serverCertFile = `./roots.pem`;
    const mqttBridgeHostname = `mqtt.googleapis.com`;
    const mqttBridgePort = 8883;
    // const messageType = `events`;
    // const numMessages = 5;

    // The mqttClientId is a unique string that identifies this device. For Google
    console.log(projectId, id);
  }

}


@Component({
  selector: 'config-dialog',
  templateUrl: './config-dialog.html',
  styleUrls: ['./config-dialog.css']
})
export class ConfigDialog implements OnInit {
  public Q;
  public levas;
  public SelectLevas = ['Leva1', 'Leva2'];
  public LevaIndex;
  selectionLeva;
  public device = '';
  public place = '';

  constructor(private iot: MarkersService,
    public dialogRef: MatDialogRef<ConfigDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private snack: MatSnackBar) {
      this.Q = data['Q'];
      //this.levas = data['levas']
      this.device = [data.zone, data.city, data.office, data.name].join('-');
      this.place = [data.zone, data.city, data.office].join('-');

    }
    
  ngOnInit(){
    this.iot.getIOsDetail(this.place).subscribe(result =>{
      let ios = result['devices']['IO'];
      for(let out in ios)
      {
        if(ios[out]['bd_id'] == this.device)
        {
          this.levas = ios[out]['Levas'];
          //codigo antiguo se procesan las levas
          this.selectionLeva = 'Leva1';//se elije por defecto leva 1
          if(this.Q == 'Q9' || this.Q == 'Q10' || this.Q == 'Q11' ||this.Q == 'Q2')
          {
            this.SelectLevas = ['Leva1']
          }
          console.log(this.levas);
          this.loadLeva('Leva1');
        }
      }
    })

    
  }

  loadLeva(id)
  {
    this.setAll(false);
    (document.getElementById('timeIn') as HTMLInputElement).value = undefined;
    (document.getElementById('timeOut') as HTMLInputElement).value = undefined;
    let index = 0;
    if(id == 'Leva1')
    {
      index = 0;
      this.LevaIndex = 0;
    }
    if(id == 'Leva2')
    {
      index = 1;
      this.LevaIndex = 1;
    }
    if(this.levas[index]['days'] == 0x00)
      {
        this.snack.open('Esta leva no esta configurada.', '', {duration: 2500})
      }
      else
      {
        let days = this.hexToBin(this.levas[index]['days']).split('');
        let day = 6
        console.log(days)
        for(let s in days)
        {
          if(days[day] == '1')
          {
            this.task.subtasks[s].completed = true;
          }
          else
          {
            this.task.subtasks[s].completed = false;
          }
          day -= 1;
          
        }
        let timeIn = this.levas[index]['timeIn'].split('x')[1];
        timeIn = [timeIn.substring(0, 2), timeIn.substring(2, 4)].join(':');
        let timeOut = this.levas[index]['timeOut'].split('x')[1];
        timeOut = [timeOut.substring(0, 2), timeOut.substring(2, 4)].join(':');
        (document.getElementById('timeIn') as HTMLInputElement).value = timeIn;
        (document.getElementById('timeOut') as HTMLInputElement).value = timeOut;
        console.log(timeIn, timeOut);
      }

  }

  saveLeva(){
    let binval = []
    let index = 6
    for(let s in this.task.subtasks)
    {
      if(this.task.subtasks[s].completed)
      {
        binval[index] = 1
      }
      else
      {
        binval[index] = 0
      }
      index -= 1
    }
    let daysHex = '0x'+this.binToHex(binval.join(''))
    let timeIn = '0x'+((document.getElementById('timeIn') as HTMLInputElement).value.split(':')).join('');
    let timeOut = '0x'+((document.getElementById('timeOut') as HTMLInputElement).value.split(':')).join('');
    console.log(daysHex, timeIn, timeOut, this.levas);
    this.levas[this.LevaIndex] = {'days': daysHex, 'timeIn': timeIn, 'timeOut': timeOut};
    this.dialogRef.close(this.levas);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  hexToBin(value)
  {
    return (parseInt(value, 16).toString(2)).padStart(7, '0');
  }

  binToHex(value){
    return parseInt(value, 2).toString(16).toUpperCase();
  }

  //** --- Aqui va los dias de semana **/
  task: Task = {
    name: 'Todos los dias',
    completed: false,
    color: 'primary',
    subtasks: [      
      {name: 'Domingo', completed: false, color: 'warn'},
      {name: 'Lunes', completed: false, color: 'primary'},
      {name: 'Martes', completed: false, color: 'primary'},
      {name: 'Miercoles', completed: false, color: 'primary'},
      {name: 'Jueves', completed: false, color: 'primary'},
      {name: 'Viernes', completed: false, color: 'primary'},
      {name: 'Sabado', completed: false, color: 'warn'}
    ]
  };

  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => t.completed = completed);
  }

}